import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useDragAndDropperStyles = makeStyles(() => {
  return createStyles({
    dragAndDroper: {
      cursor: 'move',
      position: 'relative',
      display: 'inline-block',
      width: '100%',
    },
  })
})
